var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import 'cross-fetch/polyfill';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import * as Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import * as constants from '@adc/constants';
import configment from '@adc/configment';
import responseParsers from './responseParsers';
import timeout from './timeout';
import * as common from './common';
import { defaultFetchOptions, } from './types';
import * as types from './types';
import graphFactory from './graph';
import withProgress from './withProgress';
import { usesProxy, generateProxyRoute } from './proxyRoutes';
import wellKnownSymbols from './wellKnownSymbols';
var defaultBrowserOpts = Object.freeze(__assign(__assign({}, defaultFetchOptions), { credentials: 'same-origin', useProxy: true }));
var DEFAULT_FETCH_TIMEOUT = 8000;
var patchedFetch = function (url, passedOptions) {
    if (passedOptions === void 0) { passedOptions = {}; }
    var requestController = passedOptions.controller || new AbortController();
    passedOptions.requestTimeout = Number(passedOptions.requestTimeout ||
        configment.get('REQUEST_TIMEOUT', DEFAULT_FETCH_TIMEOUT));
    var options = _.merge(_.cloneDeep(defaultBrowserOpts), passedOptions);
    options.headers[constants.headers.CORRELATION_HEADER] =
        uuidv4();
    var xsrfValue = Cookies.get(constants.cookies.XSRF_COOKIE);
    if (xsrfValue) {
        ;
        options.headers[constants.headers.XSRF_HEADER] =
            xsrfValue;
    }
    if (_.get(this, '__internal.host')) {
        url = this.__internal.host + url;
    }
    if (options.useProxy && usesProxy(url)) {
        url = generateProxyRoute(url).route;
    }
    url = common.constructUrl(url, options.queryParams);
    common.stripNonStandardFetchOptions(options);
    common.attemptAutomaticBodySerialization(options);
    options.headers['user-agent'] =
        options.headers['user-agent'] || common.userAgent();
    var tries = options.tries, retryTimeout = options.retryTimeout, requestTimeout = options.requestTimeout, eventCapture = options.eventCapture, parseResponse = options.parseResponse, queryParams = options.queryParams, fetchOptions = __rest(options, ["tries", "retryTimeout", "requestTimeout", "eventCapture", "parseResponse", "queryParams"]);
    fetchOptions.signal = requestController.signal;
    return timeout(common.executeRequest(url, fetchOptions, {
        tries: tries,
        retryTimeout: retryTimeout,
        eventCapture: eventCapture,
        parseResponse: parseResponse,
    }), requestTimeout || DEFAULT_FETCH_TIMEOUT, requestController);
};
patchedFetch.get = common.methodFactory(patchedFetch, 'GET');
patchedFetch.post = common.methodFactory(patchedFetch, 'POST');
patchedFetch.put = common.methodFactory(patchedFetch, 'PUT');
patchedFetch.patch = common.methodFactory(patchedFetch, 'PATCH');
patchedFetch.delete = common.methodFactory(patchedFetch, 'DELETE');
patchedFetch.__internal = {};
var forAuctionGraph = graphFactory(patchedFetch);
var fromService = common.boundedFetchFactory(patchedFetch);
var serializeParams = common.serializeParams;
patchedFetch.forAuctionGraph = forAuctionGraph;
patchedFetch.fromService = fromService;
patchedFetch.withProgress = withProgress;
patchedFetch.serializeParams = serializeParams;
patchedFetch.responseParsers = responseParsers;
export default patchedFetch;
export { forAuctionGraph, fromService, serializeParams, responseParsers, types, withProgress, wellKnownSymbols, };
//# sourceMappingURL=esm.js.map